/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import { FormResponse } from './types'
import { useGetFilterSelections } from '@/catalog-apps/hooks/useGetFilterSelections'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { useGetPageFilters } from '../../AppPage2/Filter/useGetPageFilters'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'
import { TComponentType } from '../../AppPage2/types'
// const formResponse = json as FormResponse

const USE_MOCK_DATA = false

interface GetFormParams {
  appKey?: string
  contentId?: string
  projectId?: number
  filterSelections: Record<string, any>[]
  isPageBuilder?: boolean
}
const getForm = async ({ appKey, contentId, projectId, filterSelections, isPageBuilder }: GetFormParams) => {
  if (!appKey || !contentId || !projectId) {
    throw new Error('Missing required parameters')
  }
  if (isPageBuilder) {
    return Promise.resolve({
      ...(await import('@/catalog-apps/mock-data/form/form-cascading-debug.json')).json,
    } as FormResponse)
  }
  if (USE_MOCK_DATA) {
    return Promise.resolve({
      // ...(await import('@/catalog-apps/mock-data/form/form-response-2.json')).json,
      ...(await import('@/catalog-apps/mock-data/form/form-response-cascading-cards-2.json')).json,
    } as FormResponse)
  }
  // return formResponse
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  if (!token) {
    throw new Error('No token found')
  }
  // const url = `${ENDPOINTS.CC_GATEWAY}/content`
  const url = `${ENDPOINTS.CC_DOTNET}/content`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      app_id: appKey,
      content_id: contentId,
      // content_id: '/showcase/full/form',
      project_id: projectId,
      filters: filterSelections,
    }),
  })
  const data = (await response.json()) as FormResponse
  if (response.ok) {
    return data
  }
  throw new Error('Failed to fetch form')
}

export function useGetForm(contentId: string, tileFilterSelections: Record<string, any>[]) {
  const isPageBuilder = useIsPageBuilder()
  const {
    data: { defaultSelections },
  } = useGetPageFilters()
  const { filterSelections } = useGetFilterSelections()
  const { appKey, projectId } = useAppContext()
  const filterSelectionsArray =
    filterSelections.length > 0
      ? [...filterSelections, ...tileFilterSelections]
      : [...defaultSelections, ...tileFilterSelections]
  const componentType: TComponentType = 'form'
  return useSuspenseQuery({
    queryKey: [contentId, componentType, appKey, projectId, filterSelectionsArray, isPageBuilder],
    queryFn: () => getForm({ appKey, contentId, projectId, filterSelections: filterSelectionsArray, isPageBuilder }),
  })
}
